import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { newSmart, useRouter, useUIComponents, useTranslate, } from "@bluelibs/x-ui";
import { useState, useMemo } from "react";
import { ProfilesAntTableSmart } from "./ProfilesTableSmart";
import { PlusOutlined, FilterOutlined } from "@ant-design/icons";
import * as Ant from "antd";
import { Routes } from "@bundles/UIAppBundle";
import { features } from "../../config/features";
import { ProfilesListFilters } from "./ProfilesListFilters";
const getRowsPerPage = () => {
    const pageHeight = document.documentElement.clientHeight;
    const tableRowHeight = 45; // px
    const heightOfOtherDivs = 214; // px
    return Math.floor((pageHeight - heightOfOtherDivs) / tableRowHeight);
};
export function ProfilesList() {
    const UIComponents = useUIComponents();
    const router = useRouter();
    const t = useTranslate();
    const [api, Provider] = newSmart(ProfilesAntTableSmart, {
        perPage: getRowsPerPage(),
    });
    const [filtersOpened, setFiltersOpened] = useState(false);
    const onFiltersUpdate = useMemo(() => {
        return (filters) => {
            api.setFlexibleFilters(filters);
        };
    }, []);
    return (_jsxs(UIComponents.AdminLayout, { children: [api.state.isError && (_jsx(Ant.Alert, { type: "error", message: t("generics.error_message") })), _jsx(Ant.Layout.Content, { children: _jsx(Provider, { children: _jsxs("div", { className: "page-profiles-list", children: [_jsxs("div", { className: "search-bar", children: [_jsx(Ant.Input.Search, { name: "Search", placeholder: t("management.profiles.actions.search"), 
                                        // className="search"
                                        onKeyUp: (e) => {
                                            const value = e.target.value;
                                            api.setFilters({
                                                $or: [
                                                    {
                                                        email: new RegExp(`${value}`, "i"),
                                                    },
                                                    {
                                                        lastName: new RegExp(`${value}`, "i"),
                                                    },
                                                    {
                                                        firstName: new RegExp(`${value}`, "i"),
                                                    },
                                                    {
                                                        phone: new RegExp(`${value}`, "i"),
                                                    },
                                                ],
                                            });
                                        } }), _jsx(Ant.Button, { onClick: () => setFiltersOpened(!filtersOpened), icon: _jsx(FilterOutlined, {}), children: t("generics.list_filters") }, "2"), features.create ? (_jsx(Ant.Button, { type: "primary", onClick: () => router.go(Routes.PROFILES_CREATE), icon: _jsx(PlusOutlined, {}), children: t("management.profiles.list.create_btn") }, "1")) : null] }), filtersOpened && (_jsx(ProfilesListFilters, { onUpdate: onFiltersUpdate })), _jsx(Ant.Table, { className: "table", ...api.getTableProps(), size: "small" })] }) }) })] }));
}
